import type { CountryIso } from "~/types";

const indonesiaEligibleNationalities: CountryIso[] = [
  "AUT",
  "BEL",
  "BGR",
  "HRV",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "IRL",
  "ITA",
  "LVA",
  "LTU",
  "LUX",
  "MLT",
  "NLD",
  "POL",
  "PRT",
  "ROU",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "ALB",
  "AND",
  "ARG",
  "ARM",
  "AUS",
  "BHR",
  "BLR",
  "BIH",
  "BRA",
  "CAN",
  "CHL",
  "CHN",
  "COL",
  "ECU",
  "EGY",
  "GTM",
  "HKG",
  "ISL",
  "IND",
  "JPN",
  "JOR",
  "KAZ",
  "KEN",
  "KWT",
  "LIE",
  "MAC",
  "MDV",
  "MEX",
  "MCO",
  "MNG",
  "MAR",
  "MOZ",
  "NZL",
  "NOR",
  "OMN",
  "PSE",
  "PNG",
  "PER",
  "QAT",
  "RUS",
  "RWA",
  "SMR",
  "SAU",
  "SRB",
  "SYC",
  "ZAF",
  "KOR",
  "SUR",
  "CHE",
  "TWN",
  "TZA",
  "TLS",
  "TUN",
  "TUR",
  "UKR",
  "ARE",
  "GBR",
  "USA",
  "UZB",
  "VAT",
  "VEN"
];

export default indonesiaEligibleNationalities;